import PartSingleOrderView from "../PartSingleOrderView";

function PartLoanDetails({
  closeLoanView,
  selectedItem,
  userName,
  isOd,
  setIndexRerender,
  setPartUserView,
}) {
  return (
    <>
      <div className=" pt-3">
        <div className=" h-[45px] w-full bg-white rounded-lg flex items-center px-4">
          <p className=" text-sm">
            <span
              className="cursor-pointer hover:underline transition ease-in-out duration-500 hover:font-medium"
              onClick={() => closeLoanView()}
            >
              {" "}
              List of Users{" "}
            </span>
            <span className=" font-bold text-base text-[#262626]">
              {" "}
              &gt; {userName || "---"}{" "}
            </span>
          </p>
        </div>
      </div>
      <div className=" pb-3">
        <PartSingleOrderView
          closeLoanView={closeLoanView}
          partial={true}
          orderId={selectedItem?.orderId}
          userId={selectedItem?.userId}
          isOd={isOd}
          setIndexRerender={setIndexRerender}
          setPartUserView={setPartUserView}
        />
      </div>
    </>
  );
}

export default PartLoanDetails;
